/**
 * @author: Ronan
 * @param:
 */
import React, { Component } from 'react';

const mapModelToProps = mappingFunc => WrappedComponent => class extends Component {
  render() {
    let newProps = {};
    if (_.isFunction(mappingFunc)) {
      newProps = mappingFunc(this.props);
    }

    return (
      <WrappedComponent
        {...this.props}
        {...newProps}
      />
    );
  }
};

export default mapModelToProps;



// WEBPACK FOOTER //
// ./src/views/ReportListSider/components/mapModelToProps.jsx